import React, { useState } from 'react';
import { Calendar, MapPin, Clock, Users, Lock, Sparkles, Trophy, ChevronLeft, Circle, Radio } from 'lucide-react';

const TOURNAMENTS = [
  {
    name: 'תחרות יומית דרג א',
    level: 'דרג א',
    type: 'יחידים',
    date: 'יום שבת, 30 במאי',
    dateNum: '30',
    month: 'מאי',
    day: 'שבת',
    time: '09:00',
    location: 'מרכז הטניס רעננה',
    participants: 16,
    maxParticipants: 16,
    players: ['אלדד שמואלי', 'מיכאל צ׳רנונילסקי', 'TOM GELLERT', 'דרור טל', 'חיים דואני', 'חי נאור', 'גלאל שקורי', 'עמית ריפטין', 'אלכס גירשפלד', 'עילי הר לב', 'יובל דקל'],
    waitingList: 3,
    status: 'full',
  },
  {
    name: 'זוגות open',
    level: 'זוגות open',
    type: 'זוגות',
    date: 'יום שישי, 29 במאי',
    dateNum: '29',
    month: 'מאי',
    day: 'שישי',
    time: '10:00',
    location: 'מרכז הטניס רעננה',
    participants: 3,
    maxParticipants: 16,
    players: ['מיכאל + דרור', 'אלכס + עמית', 'שי גני + גל נובק'],
    waitingList: 0,
    status: 'open',
  },
  {
    name: 'תחרות יומית דרג ג',
    level: 'דרג ג',
    type: 'יחידים',
    date: 'יום שישי, 29 במאי',
    dateNum: '29',
    month: 'מאי',
    day: 'שישי',
    time: '09:00',
    location: 'מרכז הטניס רעננה',
    participants: 16,
    maxParticipants: 16,
    players: ['דוד ברמן', 'אפי סופר', 'חי שכטר', 'סלע קולקר', 'עמית אלחסוב', 'עומרי פנחס', 'אמיר בסן', 'ערן רודניצקי', 'תומר כהן', 'דניאל בלובשטיין', 'ליאם אוסטרוביץ'],
    waitingList: 7,
    status: 'full',
  },
];

// ============================================================
// OPTION 6 — Apple Premium (מינימליסטי-יוקרתי)
// ============================================================
const ApplePremium = () => (
  <div className="bg-[#fbfbfd] p-10 rounded-3xl" dir="rtl">
    <div className="text-center mb-10">
      <p className="text-orange-500 text-sm font-semibold tracking-wide">תחרויות מאי 2026</p>
      <h2 className="text-5xl font-bold text-slate-900 mt-1 tracking-tight" style={{ letterSpacing: '-0.03em' }}>
        Tournament לחזק.<br/>
        <span className="text-slate-400">לרשמה. לנצח.</span>
      </h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {TOURNAMENTS.map((t, idx) => (
        <div key={idx} className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 hover:-translate-y-1">
          {/* Header pure */}
          <div className="p-8 text-center">
            <p className="text-[11px] font-bold text-slate-400 tracking-widest uppercase">{t.type}</p>
            <h3 className="text-3xl font-bold text-slate-900 mt-2 tracking-tight" style={{ letterSpacing: '-0.02em' }}>{t.name}</h3>
            <p className="text-base text-slate-500 mt-1">{t.location}</p>
          </div>
          
          {/* Hero numbers */}
          <div className="px-8 pb-6 text-center">
            <p className="text-[10px] font-bold text-slate-400 tracking-widest">DATE & TIME</p>
            <p className="text-7xl font-bold text-slate-900 leading-none mt-1 tracking-tighter">{t.dateNum}</p>
            <p className="text-sm text-slate-500 mt-1">{t.month} · {t.day} · {t.time}</p>
          </div>
          
          {/* Status badge */}
          <div className="px-8 pb-6 flex items-center justify-center gap-2">
            <span className={`px-3 py-1 rounded-full text-xs font-bold ${
              t.status === 'full' ? 'bg-orange-50 text-orange-600' : 'bg-emerald-50 text-emerald-600'
            }`}>
              {t.status === 'full' ? '🔒 מלא' : '✨ פתוח'}
            </span>
            <span className="text-xs text-slate-400">·</span>
            <span className="text-xs font-bold text-slate-500">{t.participants}/{t.maxParticipants} משתתפים</span>
          </div>
          
          {/* CTA - Apple style */}
          <div className="px-8 pb-8 flex flex-col gap-2">
            <button className="w-full py-3 rounded-full bg-blue-500 text-white font-semibold text-base hover:bg-blue-600 transition-colors">
              {t.status === 'full' ? 'הצטרף לרשימת המתנה' : 'הירשם עכשיו'}
            </button>
            <button className="w-full py-3 text-blue-500 font-semibold text-base hover:underline">
              למידע נוסף ←
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// ============================================================
// OPTION 7 — Olympic Podium (מדליות אולימפיות)
// ============================================================
const OlympicPodium = () => (
  <div className="bg-gradient-to-br from-stone-100 to-stone-200 p-8 rounded-2xl" dir="rtl">
    <div className="text-center mb-8">
      <div className="flex items-center gap-2 justify-center">
        <div className="text-3xl">🏆</div>
        <h2 className="text-4xl font-black text-stone-900">Tournament Series</h2>
      </div>
      <p className="text-stone-500 mt-2">מאי · ליגת המאסטרס 2026</p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {TOURNAMENTS.map((t, idx) => {
        const medals = [
          { color: 'from-amber-300 via-yellow-500 to-amber-600', label: 'GOLD', text: 'text-amber-900', ring: 'ring-amber-300' },
          { color: 'from-slate-300 via-slate-400 to-slate-500', label: 'SILVER', text: 'text-slate-800', ring: 'ring-slate-300' },
          { color: 'from-orange-600 via-amber-700 to-orange-800', label: 'BRONZE', text: 'text-amber-100', ring: 'ring-orange-400' },
        ];
        const medal = medals[idx % 3];
        
        return (
          <div key={idx} className="relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all">
            {/* Medal hero */}
            <div className={`relative h-44 bg-gradient-to-br ${medal.color} overflow-hidden`}>
              {/* Engraved pattern */}
              <div className="absolute inset-0 opacity-20" style={{
                backgroundImage: 'repeating-conic-gradient(from 0deg at 50% 50%, transparent 0deg, rgba(255,255,255,0.3) 5deg, transparent 10deg)',
              }} />
              
              {/* Medal center */}
              <div className="relative h-full flex items-center justify-center">
                <div className={`w-28 h-28 rounded-full bg-gradient-to-br ${medal.color} ring-4 ring-offset-2 ${medal.ring} ring-offset-white/30 shadow-2xl flex items-center justify-center`}>
                  <div className="text-center">
                    <Trophy className={`w-8 h-8 ${medal.text} mx-auto`} />
                    <p className={`text-[10px] ${medal.text} font-black tracking-widest mt-1`}>{medal.label}</p>
                  </div>
                </div>
              </div>
              
              {/* Status corner */}
              <div className="absolute top-3 right-3">
                <span className={`px-2 py-1 rounded-full text-[10px] font-black tracking-wider backdrop-blur-md ${
                  t.status === 'full' ? 'bg-black/30 text-white' : 'bg-white/30 text-white'
                }`}>
                  {t.status === 'full' ? 'מלא' : 'פתוח'}
                </span>
              </div>
            </div>
            
            {/* Podium step */}
            <div className="px-6 pt-5 pb-6 -mt-4 relative bg-white rounded-t-3xl shadow-inner">
              <p className="text-[10px] text-stone-400 font-bold tracking-widest text-center">{t.type}</p>
              <h3 className="text-2xl font-black text-stone-900 text-center mt-1">{t.name}</h3>
              
              {/* Info pills */}
              <div className="flex items-center justify-center gap-2 mt-3 mb-4">
                <div className="px-3 py-1 bg-stone-100 rounded-full text-xs font-bold text-stone-700 flex items-center gap-1">
                  <Calendar className="w-3 h-3" /> {t.dateNum} {t.month}
                </div>
                <div className="px-3 py-1 bg-stone-100 rounded-full text-xs font-bold text-stone-700 flex items-center gap-1">
                  <Clock className="w-3 h-3" /> {t.time}
                </div>
              </div>
              
              <div className="text-center text-xs text-stone-500 mb-4 flex items-center justify-center gap-1">
                <MapPin className="w-3 h-3" /> {t.location}
              </div>
              
              {/* Progress */}
              <div className="mb-4">
                <div className="flex justify-between text-[10px] font-bold mb-1">
                  <span className="text-stone-500">תפוסה</span>
                  <span className="text-stone-900">{t.participants}/{t.maxParticipants}</span>
                </div>
                <div className="h-2 bg-stone-100 rounded-full overflow-hidden">
                  <div className={`h-full bg-gradient-to-r ${medal.color}`} style={{ width: `${(t.participants / t.maxParticipants) * 100}%` }} />
                </div>
              </div>
              
              <button className={`w-full py-3 rounded-2xl font-black text-sm shadow-lg transition-all hover:scale-[1.02] bg-gradient-to-r ${medal.color} ${medal.text}`}>
                {t.status === 'full' ? '⏳ רשימת המתנה' : '🏅 הירשם לתחרות'}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

// ============================================================
// OPTION 8 — Live Stream Style (כמו Twitch)
// ============================================================
const LiveStreamCards = () => (
  <div className="bg-[#0e0e10] p-8 rounded-2xl" dir="rtl">
    <div className="flex items-baseline justify-between mb-6 border-b border-slate-800 pb-3">
      <div>
        <p className="text-purple-400 text-xs font-bold tracking-widest">🔴 LIVE EVENTS</p>
        <h2 className="text-3xl font-black text-white mt-1">תחרויות מאי</h2>
      </div>
      <div className="text-slate-400 text-xs">{TOURNAMENTS.length} תחרויות זמינות</div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
      {TOURNAMENTS.map((t, idx) => (
        <div key={idx} className="bg-[#18181b] rounded-lg overflow-hidden hover:ring-2 hover:ring-purple-500 transition-all cursor-pointer group">
          {/* Thumbnail-style hero */}
          <div className={`relative aspect-video overflow-hidden ${
            t.status === 'full' 
              ? 'bg-gradient-to-br from-red-900 via-orange-900 to-amber-900'
              : 'bg-gradient-to-br from-emerald-900 via-teal-900 to-cyan-900'
          }`}>
            {/* Tennis court overlay */}
            <div className="absolute inset-0 flex items-center justify-center opacity-30">
              <div className="w-3/4 h-1/2 border-2 border-white rounded-sm relative">
                <div className="absolute top-1/2 left-0 right-0 h-px bg-white" />
                <div className="absolute top-0 bottom-0 left-1/2 w-px bg-white" />
                <div className="absolute inset-x-1/4 top-1/4 bottom-1/4 border border-white" />
              </div>
            </div>
            
            {/* Live indicator */}
            {t.status === 'open' && (
              <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2 py-1 bg-red-600 rounded text-white text-[10px] font-black">
                <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                פתוח להרשמה
              </div>
            )}
            {t.status === 'full' && (
              <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2 py-1 bg-slate-800/80 backdrop-blur rounded text-slate-300 text-[10px] font-black">
                <Lock className="w-3 h-3" />
                מלא
              </div>
            )}
            
            {/* Viewer count (participants) */}
            <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/70 backdrop-blur rounded text-white text-[10px] font-bold flex items-center gap-1">
              <Users className="w-3 h-3" /> {t.participants}/{t.maxParticipants}
            </div>
            
            {/* Time stamp */}
            <div className="absolute bottom-3 left-3 px-2 py-0.5 bg-black/70 backdrop-blur rounded text-white text-[10px] font-bold">
              {t.dateNum} {t.month} · {t.time}
            </div>
            
            {/* Big trophy emoji */}
            <div className="absolute inset-0 flex items-center justify-center">
              <Trophy className="w-16 h-16 text-white/40 group-hover:text-white/60 group-hover:scale-110 transition-all" />
            </div>
          </div>
          
          {/* Info row */}
          <div className="p-4 flex gap-3">
            {/* Avatar */}
            <div className={`w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center font-black text-white ${
              t.status === 'full' ? 'bg-gradient-to-br from-orange-500 to-red-500' : 'bg-gradient-to-br from-emerald-500 to-teal-500'
            }`}>
              {t.level.charAt(t.level.length - 1)}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-white font-bold text-base truncate group-hover:text-purple-400 transition-colors">{t.name}</h3>
              <p className="text-slate-400 text-xs">{t.location}</p>
              <div className="flex flex-wrap gap-1 mt-2">
                <span className="text-[10px] px-2 py-0.5 bg-slate-700 text-slate-300 rounded font-semibold">{t.type}</span>
                <span className="text-[10px] px-2 py-0.5 bg-purple-900/50 text-purple-300 rounded font-semibold">{t.level}</span>
              </div>
            </div>
          </div>
          
          {/* CTA */}
          <div className="px-4 pb-4">
            <button className={`w-full py-2.5 rounded-md font-black text-sm transition-all ${
              t.status === 'full'
                ? 'bg-slate-700 hover:bg-slate-600 text-slate-200'
                : 'bg-purple-600 hover:bg-purple-500 text-white'
            }`}>
              {t.status === 'full' ? 'הירשם לרשימת המתנה' : '⚡ הירשם עכשיו'}
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// ============================================================
// OPTION 9 — Brutalist Modern (טרנדי 2026)
// ============================================================
const BrutalistModern = () => (
  <div className="bg-[#fef3c7] p-10 rounded-2xl" dir="rtl">
    <div className="mb-10">
      <p className="text-[10px] tracking-[0.5em] text-black font-black uppercase">— Daily Tournaments —</p>
      <h2 className="text-7xl font-black text-black mt-2 tracking-tighter leading-none" style={{ letterSpacing: '-0.05em' }}>
        מאי<span className="text-red-500">.</span>2026<span className="text-red-500">.</span>
      </h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {TOURNAMENTS.map((t, idx) => {
        const bgColors = ['bg-orange-400', 'bg-emerald-400', 'bg-purple-400'];
        const bg = bgColors[idx % 3];
        return (
          <div key={idx} className={`relative ${bg} border-4 border-black p-6 rounded-none transition-all hover:translate-x-1 hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#000]`} style={{
            boxShadow: '6px 6px 0 0 #000'
          }}>
            {/* Number */}
            <div className="absolute -top-3 -right-3 bg-black text-white px-3 py-1 font-black text-sm">
              #{idx + 1}
            </div>
            
            {/* Status badge - extreme */}
            <div className={`inline-block px-3 py-1 border-2 border-black font-black text-xs uppercase tracking-wider ${
              t.status === 'full' ? 'bg-red-500 text-white' : 'bg-white text-black'
            }`}>
              {t.status === 'full' ? '★ FULL ★' : '★ OPEN ★'}
            </div>
            
            <h3 className="text-3xl font-black text-black mt-4 leading-none tracking-tighter" style={{ letterSpacing: '-0.03em' }}>
              {t.name}
            </h3>
            <p className="text-black/70 font-bold mt-1 text-sm">{t.level} · {t.type}</p>
            
            {/* Big date */}
            <div className="mt-6 bg-black text-white p-4 rounded-none">
              <div className="flex items-end justify-between">
                <div>
                  <p className="text-[10px] tracking-widest text-white/60 font-bold">DATE</p>
                  <p className="text-5xl font-black leading-none tracking-tighter">{t.dateNum}</p>
                  <p className="text-xs font-bold mt-1">{t.month} · {t.day}</p>
                </div>
                <div className="text-left">
                  <p className="text-[10px] tracking-widest text-white/60 font-bold">TIME</p>
                  <p className="text-3xl font-black leading-none">{t.time}</p>
                </div>
              </div>
            </div>
            
            {/* Info */}
            <div className="mt-4 space-y-1 text-sm font-bold text-black">
              <p className="flex items-center gap-2"><span className="text-lg">📍</span> {t.location}</p>
              <p className="flex items-center gap-2"><span className="text-lg">👥</span> {t.participants} / {t.maxParticipants} משתתפים</p>
              {t.waitingList > 0 && (
                <p className="flex items-center gap-2"><span className="text-lg">⏳</span> {t.waitingList} ברשימת המתנה</p>
              )}
            </div>
            
            {/* CTA - brutalist button */}
            <button className="w-full mt-5 py-4 bg-black hover:bg-red-500 text-white font-black text-base uppercase tracking-wider transition-colors border-2 border-black">
              {t.status === 'full' ? '→ Join Waitlist ←' : '→ Register Now ←'}
            </button>
          </div>
        );
      })}
    </div>
  </div>
);

// ============================================================
// OPTION 10 — Tennis Court Theme (מגרש טניס אמיתי)
// ============================================================
const TennisCourtTheme = () => (
  <div className="bg-[#1a4d2e] p-8 rounded-2xl" dir="rtl" style={{
    backgroundImage: 'linear-gradient(135deg, #1a4d2e 0%, #2d6a4f 50%, #1a4d2e 100%)'
  }}>
    <div className="text-center mb-8">
      <p className="text-yellow-300 text-xs tracking-[0.4em] font-bold">★ TENNIS PRO ISRAEL ★</p>
      <h2 className="text-4xl font-black text-white mt-2" style={{ fontFamily: 'Georgia, serif' }}>
        Match Schedule
      </h2>
      <p className="text-emerald-200 text-sm mt-1">מאי · 2026</p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {TOURNAMENTS.map((t, idx) => (
        <div key={idx} className="relative bg-[#2d6a4f] rounded-2xl overflow-hidden shadow-2xl hover:scale-[1.02] transition-transform">
          {/* Court lines pattern */}
          <div className="relative h-44 bg-gradient-to-br from-[#2d6a4f] via-[#52b788] to-[#2d6a4f] overflow-hidden border-4 border-white">
            {/* Court center line */}
            <div className="absolute top-1/2 left-0 right-0 h-1 bg-white" />
            {/* Service boxes */}
            <div className="absolute inset-x-[15%] top-[15%] bottom-[15%] border-2 border-white" />
            {/* Center service line */}
            <div className="absolute top-[15%] bottom-[15%] left-1/2 w-1 bg-white -translate-x-1/2" />
            
            {/* Tennis ball decoration */}
            <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-yellow-300 shadow-lg flex items-center justify-center" style={{
              backgroundImage: 'radial-gradient(circle at 35% 35%, #fef08a, #facc15)'
            }}>
              <div className="absolute inset-0 rounded-full" style={{
                backgroundImage: 'linear-gradient(45deg, transparent 47%, white 48%, white 52%, transparent 53%)'
              }} />
            </div>
            
            {/* Title overlay */}
            <div className="absolute bottom-3 right-3 left-3 text-center">
              <p className="text-yellow-300 text-[10px] font-black tracking-widest">{t.type.toUpperCase()}</p>
              <h3 className="text-white text-2xl font-black drop-shadow-lg" style={{ fontFamily: 'Georgia, serif' }}>
                {t.name}
              </h3>
            </div>
            
            {/* Status flag */}
            <div className="absolute top-3 left-3">
              <div className={`px-3 py-1 font-black text-[10px] tracking-widest shadow-lg ${
                t.status === 'full' 
                  ? 'bg-red-600 text-white' 
                  : 'bg-yellow-400 text-emerald-900'
              }`}>
                {t.status === 'full' ? 'COURT FULL' : 'BOOK NOW'}
              </div>
            </div>
          </div>
          
          {/* Info section - scoreboard style */}
          <div className="bg-[#1a4d2e] p-5">
            {/* Score-like stats */}
            <div className="grid grid-cols-3 gap-2 mb-4 bg-black/30 rounded-lg p-3 border border-yellow-300/30">
              <div className="text-center">
                <p className="text-yellow-300 text-[9px] font-black tracking-widest">DATE</p>
                <p className="text-white text-lg font-black leading-none mt-1" style={{ fontFamily: 'Georgia, serif' }}>{t.dateNum}</p>
                <p className="text-emerald-200 text-[9px]">{t.month}</p>
              </div>
              <div className="text-center border-x border-yellow-300/30">
                <p className="text-yellow-300 text-[9px] font-black tracking-widest">TIME</p>
                <p className="text-white text-lg font-black leading-none mt-1" style={{ fontFamily: 'Georgia, serif' }}>{t.time}</p>
                <p className="text-emerald-200 text-[9px]">{t.day}</p>
              </div>
              <div className="text-center">
                <p className="text-yellow-300 text-[9px] font-black tracking-widest">SLOTS</p>
                <p className="text-white text-lg font-black leading-none mt-1" style={{ fontFamily: 'Georgia, serif' }}>{t.participants}</p>
                <p className="text-emerald-200 text-[9px]">/ {t.maxParticipants}</p>
              </div>
            </div>
            
            {/* Location */}
            <div className="flex items-center gap-2 text-sm text-emerald-100 mb-3">
              <MapPin className="w-4 h-4 text-yellow-300" />
              <span className="font-semibold" style={{ fontFamily: 'Georgia, serif' }}>{t.location}</span>
            </div>
            
            {/* Players preview */}
            <div className="mb-4">
              <p className="text-yellow-300 text-[10px] font-black tracking-widest mb-1">PLAYERS</p>
              <div className="flex items-center">
                {t.players.slice(0, 4).map((p, i) => (
                  <div key={i} className="w-7 h-7 rounded-full border-2 border-[#1a4d2e] shadow-md flex items-center justify-center text-emerald-900 text-[10px] font-black bg-yellow-300" style={{
                    marginRight: i === 0 ? 0 : '-6px',
                    zIndex: 4 - i
                  }} title={p}>
                    {p.charAt(0)}
                  </div>
                ))}
                {t.players.length > 4 && (
                  <div className="w-7 h-7 rounded-full bg-emerald-700 border-2 border-[#1a4d2e] shadow-md flex items-center justify-center text-yellow-300 text-[9px] font-black" style={{ marginRight: '-6px' }}>
                    +{t.players.length - 4}
                  </div>
                )}
              </div>
            </div>
            
            {/* CTA - scoreboard button */}
            <button className={`w-full py-3 rounded-md font-black text-sm tracking-widest shadow-lg transition-all hover:scale-105 ${
              t.status === 'full'
                ? 'bg-red-600 hover:bg-red-700 text-white border-2 border-red-400'
                : 'bg-yellow-400 hover:bg-yellow-300 text-emerald-900 border-2 border-yellow-300'
            }`} style={{ fontFamily: 'Georgia, serif' }}>
              {t.status === 'full' ? 'JOIN WAITLIST' : 'REGISTER NOW'}
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// ============================================================
// MAIN PAGE
// ============================================================
const OPTIONS = [
  { key: 'apple', label: '🍎 Apple Premium', component: ApplePremium, desc: 'מינימליסטי-יוקרתי כמו אפל — Hero number ענקי, פונט נקי, כפתורים מעוגלים. תחושה של iPhone Launch.' },
  { key: 'olympic', label: '🥇 Olympic Podium', component: OlympicPodium, desc: 'מדליות אולימפיות — Gold/Silver/Bronze לכל תחרות, גרדיאנטים מתכתיים, תחושת אליפות יוקרתית.' },
  { key: 'twitch', label: '🔴 Live Stream', component: LiveStreamCards, desc: 'סגנון Twitch/YouTube — thumbnail עם מגרש טניס, סמן LIVE אדום מהבהב, viewer-count. ימודרני-Gen-Z.' },
  { key: 'brutalist', label: '⚫ Brutalist Modern', component: BrutalistModern, desc: 'טרנדי 2026 — צבעים בולטים, בורדרים שחורים עבים, צללים גרפיים, טיפוגרפיה ענקית. WOW מקסימלי.' },
  { key: 'tennis', label: '🎾 Tennis Court', component: TennisCourtTheme, desc: 'מגרש טניס אמיתי — קווי משחק, כדור צהוב מהבהב, סקורבורד פנימי, ירוק עמוק. ספציפי למותג.' },
];

const TournamentsPreviewPage = () => {
  const [selected, setSelected] = useState('brutalist');
  const Selected = OPTIONS.find(o => o.key === selected);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100" dir="rtl">
      <div className="bg-white border-b shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h1 className="text-2xl font-black text-slate-900">🎨 הדמיה - חבילה 2</h1>
              <p className="text-sm text-slate-500">5 כיוונים חדשים לגמרי. בחר/י את האהוב עליך.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {OPTIONS.map(opt => (
                <button
                  key={opt.key}
                  onClick={() => setSelected(opt.key)}
                  data-testid={`tour2-option-${opt.key}`}
                  className={`px-4 py-2 rounded-xl text-sm font-bold transition-all ${
                    selected === opt.key
                      ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg scale-105'
                      : 'bg-white border border-slate-200 text-slate-700 hover:border-purple-300 hover:bg-purple-50'
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
          <div className="mt-3 px-4 py-2 bg-purple-50 border border-purple-200 rounded-lg">
            <p className="text-sm text-purple-900"><strong>{Selected.label}:</strong> {Selected.desc}</p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto p-6">
        <Selected.component />
      </div>

      <div className="max-w-7xl mx-auto p-6 pb-12">
        <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-8 text-center text-white shadow-xl">
          <h3 className="text-2xl font-black mb-2">בחרת? 🎯</h3>
          <p className="text-purple-100">כתוב/י לי בצ׳אט איזה סגנון אהבת ואני אבנה אותו באתר.</p>
        </div>
      </div>
    </div>
  );
};

export default TournamentsPreviewPage;
